module.exports = __webpack_public_path__ + "img/dc-logo-web.com-black.3626fab2.png";